module.exports = __webpack_public_path__ + "static/media/skip_previous-24px.e66b0a10.svg";